import * as routes from "@/router/routes";

export function checkIsAuth(to, from, next) {
    next();
    // if (localStorage.getItem("authenticated") == "true") {
    //   next();
    // } else {
    //   next(routes.Login);
    // }
}

export function checkIsNotAuth(to, from, next) {
    next();
    // if (localStorage.getItem("authenticated") != "true") {
    //   next();
    // } else {
    //   next(routes.Root);
    // }
}
